/**
 * Author：brand
 * Creation Time：2019-05-13 16:30
 * Email：brandhuang@qq.com
 */

import store from '@/store/index'
import router from "./router/router";
import {getToken, removeToken} from "@/utils/auth";

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

let whiteList = ['/login', '/register', '/forget','/expire', '/authLogin']

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + " | 微聊客服" : '' + "微聊客服"
  if (getToken()) { // 判断是否有token
    if (to.path === '/login') {
      next('/')
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('user/userInfo',router).then( info => { // 拉取user_info
          store.dispatch('permission/generateRoutes', info.data.menu).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            // next()
          })
        }).catch((err) => {
          store.dispatch('user/resetToken').then(() => {
            next({ path: '/' })
          })
        })
      } else {
        // // 没有动态改变权限的需求可直接next() 删除下方权限判断
        // if (hasPermission(store.getters.roles, to.meta.roles)) {
        //   next()//
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        // }
        next()
      }
    }
  } else { // 未获取道token
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})

router.afterEach(() => {

})
